import "core-js/modules/es.array.concat.js";
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue";
var _hoisted_1 = {
  class: "content"
};
var _hoisted_2 = {
  class: "resource-preview"
};
var _hoisted_3 = {
  class: "resource-list"
};
var _hoisted_4 = ["onClick"];
var _hoisted_5 = ["src"];
import { ref, onMounted } from 'vue';
/* 组件 */
import preview from './preview';
export default {
  __name: 'resourcePreview',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    sourceArr: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  emits: ['update:visible'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    /* 工具 */
    var emit = __emit;
    var sourceData = ref(null);
    var activeIndex = ref(0);

    /* 方法 */
    onMounted(function () {
      sourceData.value = __props.sourceArr[0];
    });
    var changeItem = function changeItem(item, index) {
      sourceData.value = item;
      activeIndex.value = index;
    };
    var hide = function hide() {
      emit('update:visible', false);
    };
    return function (_ctx, _cache) {
      var _sourceData$value, _sourceData$value2;
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_t_dialog = _resolveComponent("t-dialog");
      return _openBlock(), _createBlock(_component_t_dialog, {
        visible: __props.visible,
        footer: false,
        width: "960px",
        header: "".concat((_sourceData$value = sourceData.value) === null || _sourceData$value === void 0 ? void 0 : _sourceData$value.teamNameExt, " ").concat((_sourceData$value2 = sourceData.value) === null || _sourceData$value2 === void 0 ? void 0 : _sourceData$value2.studentName),
        placement: "center",
        class: "show-resource-dialog",
        onClose: hide
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [sourceData.value ? (_openBlock(), _createBlock(_unref(preview), {
            key: 0,
            path: sourceData.value.fileInfo.fileUrl
          }, null, 8, ["path"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.sourceArr, function (item, index) {
            return _openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass({
                'resource-item': true,
                active: activeIndex.value === index
              }),
              onClick: function onClick($event) {
                return changeItem(item, index);
              }
            }, [(item === null || item === void 0 ? void 0 : item.fileInfo.fileType) === 10 ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: item === null || item === void 0 ? void 0 : item.fileInfo.fileUrl,
              class: "img"
            }, null, 8, _hoisted_5)) : (_openBlock(), _createBlock(_component_svg_icon, {
              key: 1,
              name: "audio-icon",
              size: "60"
            }))], 10, _hoisted_4);
          }), 128))])])];
        }),
        _: 1
      }, 8, ["visible", "header"]);
    };
  }
};